import React, { useReducer, createContext, useEffect } from 'react';
import { RPCFactory } from '../../../utils/RequestUtil';

export const Context = createContext('helper');

const initState = {
  type: 'home',
  menuItem: {},
  detailItem: {},
};

export const ACTIONS = {
  BACK_TO_HOME: 'BACK_TO_HOME',
  BACK_TO_MENU: 'BACK_TO_MENU',
  GO_TO_MENU: 'GO_TO_MENUA',
  GO_TO_DETAIL: 'GO_TO_DETAIL',
  SET_MENU_DATA: 'SET_MENU_DATA',
  SET_DETAIL_DATA: 'SET_DETAIL_DATA',
  JUMP_TO_RISK_WARNING: 'JUMP_TO_RISK_WARNING',
};

const reducer = (state = initState, action = {}) => {
  const { type, payload = {} } = action;
  switch (type) {
    case ACTIONS.BACK_TO_HOME:
      return { ...initState, type: 'home' };
    case ACTIONS.BACK_TO_MENU:
      return { ...state, type: 'menu', detailItem: {} };
    case ACTIONS.GO_TO_MENU:
      return { ...state, type: 'menu', menuItem: payload };
    case ACTIONS.GO_TO_DETAIL:
      return { ...state, type: 'detail', detailItem: payload };
    case ACTIONS.SET_MENU_DATA: {
      let { menuItem } = state;
      menuItem = { ...menuItem, data: payload };
      return { ...state, menuItem };
    }
    case ACTIONS.SET_DETAIL_DATA: {
      let { detailItem } = state;
      detailItem = { ...detailItem, data: payload };
      return { ...state, detailItem };
    }
    case ACTIONS.JUMP_TO_RISK_WARNING:
      return {
        ...state,
        type: 'detail',
        detailItem: {
          id: 2463,
          title: '如何设置保护数据安全',
        },
      };
    default:
      return state;
  }
};

let _dispatch = null;

export const openRiskWarning = () => {
  if (!_dispatch) return;
  _dispatch({ type: ACTIONS.JUMP_TO_RISK_WARNING });
  const setData = resData => _dispatch({
    type: ACTIONS.SET_MENU_DATA,
    payload: resData,
  });
  RPCFactory.quickHelp
    .getCatalog(2381)
    .done(setData);
};

export const Provider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initState);

  useEffect(() => {
    _dispatch = dispatch;
  }, [dispatch]);

  return (
    <Context.Provider value={{ state, dispatch }}>
      { children }
    </Context.Provider>
  );
};
